const POPPINS = {
  black: 'Poppins-Black',
  extraBold: 'Poppins-ExtraBold',
  bold: 'Poppins-Bold',
  semiBold: 'Poppins-SemiBold',
  medium: 'Poppins-Medium',
  regular: 'Poppins-Regular',
  light: 'Poppins-Light',
  extraLight: 'Poppins-ExtraLight',
  thin: 'Poppins-Thin',
};

export const fonts = {
  POPPINS,
};
